import React, { useState } from 'react';
import { Code, BarChart, Users, Key } from 'lucide-react';
import { Switch } from '../ui/switch';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const AdvancedSettings = () => {
  const [apiEnabled, setApiEnabled] = useState(false);
  const [affiliateEnabled, setAffiliateEnabled] = useState(true);

  return (
    <div className="space-y-6">
      <Card className="bg-gray-800 border-gray-700">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Code className="w-5 h-5" />
            API Access
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-white font-medium">Enable API Access</h4>
              <p className="text-gray-400 text-sm">Generate API keys for third-party integrations</p>
            </div>
            <Switch checked={apiEnabled} onCheckedChange={setApiEnabled} />
          </div>
          {apiEnabled && (
            <div className="space-y-3 pt-4 border-t border-gray-600">
              <div className="flex items-center gap-3">
                <Input 
                  value="sk-igot-soul-abc123xyz789..." 
                  readOnly 
                  className="bg-gray-700 border-gray-600 text-white font-mono text-sm"
                />
                <Button variant="outline" className="border-gray-600 text-gray-300">
                  <Key className="w-4 h-4" />
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      <Card className="bg-gray-800 border-gray-700">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Users className="w-5 h-5" />
            Affiliate Program
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-white font-medium">Affiliate Enrollment</h4>
              <p className="text-gray-400 text-sm">Earn commissions by referring creators</p>
            </div>
            <Switch checked={affiliateEnabled} onCheckedChange={setAffiliateEnabled} />
          </div>
          {affiliateEnabled && (
            <div className="bg-green-900/20 border border-green-500/20 rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="text-green-400 font-medium">Your Affiliate Code</h4>
                  <p className="text-gray-400 text-sm font-mono">IGOTSOUL-USER123</p>
                </div>
                <div className="text-right">
                  <div className="text-green-400 font-bold">$156.75</div>
                  <div className="text-gray-400 text-sm">Earned this month</div>
                </div>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      <Card className="bg-gray-800 border-gray-700">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <BarChart className="w-5 h-5" />
            Analytics Integration
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-3">
            <div>
              <label className="text-white text-sm font-medium">Google Analytics ID</label>
              <Input 
                placeholder="UA-XXXXXXXXX-X" 
                className="bg-gray-700 border-gray-600 text-white mt-1"
              />
            </div>
            <div>
              <label className="text-white text-sm font-medium">Meta Pixel ID</label>
              <Input 
                placeholder="Facebook Pixel ID" 
                className="bg-gray-700 border-gray-600 text-white mt-1"
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdvancedSettings;
